module.exports = __webpack_public_path__ + "img/icon_support_07.5ec84a2f.png";